import { render, staticRenderFns } from "./caijiguocheng.vue?vue&type=template&id=77a1df52&scoped=true"
import script from "./caijiguocheng.vue?vue&type=script&lang=js"
export * from "./caijiguocheng.vue?vue&type=script&lang=js"
import style0 from "./caijiguocheng.vue?vue&type=style&index=0&id=77a1df52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a1df52",
  null
  
)

export default component.exports